import {
  Box,
  FormControl,
  Stack,
  TextField,
  IconButton,
  Button
} from '@mui/material';
import { styled } from '@mui/material/styles';
import SearchTwoToneIcon from '@mui/icons-material/SearchTwoTone';
import SelectDateRange from 'src/components/SelectDateRange';
import { KeyboardEvent, useEffect, useMemo, useState } from 'react';
import { useAppSelector } from 'src/app/hooks';
import ModalAddAutoClipping from 'src/components/ModalAddAutoClipping';
import ClearIcon from '@mui/icons-material/Clear';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import useQueryUrl from 'src/hooks/useQuery';
import { useNavigate } from 'react-router';
import { STREAM_PANEL_ONLINE_MEDIA } from 'src/route';
import {
  reducerUpdateFilterLanguages,
  reducerUpdateIncludeKeywords
  // reducerUpdateLanguageSelected
} from 'src/features/onlineMediaStream';
import { useDispatch } from 'react-redux';
// import LanguageAutocomplete from 'src/components/LanguageAutocomplete';
import SelectMultipleLanguage from 'src/components/SelectMultipleLanguage';
import { ILanguage } from 'src/models/general';
import TranslateButton from 'src/components/TranslateButton';
import {
  TranslateArticlePayload,
  useTranslateArticle
} from 'src/hooks/useTranslateArticle';
import {
  resetTranslation,
  setSelectedTargetLanguage
} from 'src/features/translateArticle';

const CustomBox = styled(Box)(
  ({ theme }) => `
    // width: calc(100vw - ${theme.sidebar.width} - ${theme.spacing(10)});
    margin: ${theme.spacing(2, 0)};
    // position: absolute;
`
);

const FilterBox = styled(Box)(
  ({ theme }) => `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: ${theme.spacing(2)};
`
);

function BottomHeader() {
  const query = useQueryUrl();
  const id = query.get('id');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { resTranslateArticle, isTranslated, handleClickTranslateButton } =
    useTranslateArticle();

  const { languages, includeKeywords, articleList } = useAppSelector(
    (state) => state.storeOnlineMediaStream
  );

  const [localSearch, setLocalSearch] = useState<string>(includeKeywords[0]);
  const handleSearch = () => {
    dispatch(reducerUpdateIncludeKeywords(localSearch));
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') handleSearch();
  };

  const handleClear = () => {
    setLocalSearch('');
    dispatch(reducerUpdateIncludeKeywords(''));
  };

  const handleSubmitLanguage = (languageSelected: ILanguage[]) => {
    dispatch(reducerUpdateFilterLanguages(languageSelected));
  };

  const activeArticle = useMemo(() => {
    return articleList.data.result.find((article) => article.originalId === id);
  }, [articleList.data.result, id]);

  useEffect(() => {
    return () => {
      dispatch(resetTranslation());
    };
  }, []);

  return (
    <CustomBox>
      <FilterBox flexWrap={'wrap'} alignItems={{ xs: 'end', lg: 'center' }}>
        <Stack
          direction="row"
          flexWrap={'wrap-reverse'}
          alignItems="center"
          gap={{ xs: 1, md: 2 }}
          flexGrow={1}
        >
          <TextField
            size="small"
            sx={{ maxWidth: 440 }}
            fullWidth
            InputProps={{
              startAdornment: (
                <IconButton size="small" onClick={handleSearch}>
                  <SearchTwoToneIcon />
                </IconButton>
              ),
              endAdornment: localSearch ? (
                <IconButton size="small" onClick={handleClear}>
                  <ClearIcon />
                </IconButton>
              ) : null
            }}
            placeholder="Search phrases"
            onChange={(e) => setLocalSearch(e.target.value)}
            value={localSearch}
            onKeyDown={handleKeyDown}
          />
          <ModalAddAutoClipping />
        </Stack>
        <Stack spacing={2} direction="row">
          {activeArticle && (
            <TranslateButton
              handleTranslate={(selectedLanguage: string) => {
                dispatch(setSelectedTargetLanguage(selectedLanguage));
                handleClickTranslateButton({
                  title: activeArticle.title,
                  content: activeArticle.content,
                  language: selectedLanguage ? selectedLanguage : undefined
                });
              }}
              loading={resTranslateArticle.loading}
              isTranslated={isTranslated}
            />
          )}
          <SelectMultipleLanguage
            languages={languages}
            onSubmit={handleSubmitLanguage}
          />
          <FormControl size="small" sx={{ width: 135 }}>
            <SelectDateRange />
          </FormControl>
        </Stack>
      </FilterBox>
      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        sx={{ mt: id ? 2 : 1 }}
      >
        {id && (
          <Button
            size="small"
            variant="text"
            color="primary"
            startIcon={<ArrowBackIcon />}
            sx={{
              borderRadius: 1
            }}
            onClick={() => navigate(STREAM_PANEL_ONLINE_MEDIA)}
          >
            Media Profile Preview
          </Button>
        )}
      </Stack>
    </CustomBox>
  );
}

export default BottomHeader;
